module.exports = __webpack_public_path__ + "static/img/IMG_20240210_131413.5b9437f4.jpg";